import React, { memo } from "react";
import { LinearProgress, LinearProgressProps } from "@material-ui/core";
import useAppLinearProgress from "./index.hooks";

type AppLinearProgressProps = {
  percentage?: number,
} & LinearProgressProps;

const AppLinearProgress = ({ percentage, ...props }: AppLinearProgressProps) => {
  const { styles, classes } = useAppLinearProgress(percentage === 100);

  return (
    <div className={styles.barContainer}>
      <LinearProgress
        variant={percentage ? "determinate" : "indeterminate"}
        value={percentage ?? undefined}
        classes={classes.appLinearProg}
        {...props}
      />
    </div>
    );
}

export default memo(AppLinearProgress);
